define(
    'viewmodels/secured/lists/columns',[
        "viewmodels/ViewModel",
        "providers/dataprovider",
        "i19n!i19n/strings"
    ],
    function (ViewModel, dataProvider, i19n) {
        var vm = new ViewModel(
        {
            i19n: i19n,
            id: '',
            notify: {},
            reload: {},
            comboClick: {},
            
            listAvailable: ko.observableArray([]),
            listTaken: ko.observableArray([])
        });

        vm.activate = function () {
            var self = this;

            return loadData();
        };
        vm.attached = function () {
            var self = this;

            self.$holder = $('<li class="placeholder" ><span>' + i19n.to.drophere + '</span></li>');
            self.$available = $('#availableColumns');
            self.$taken = $('#takenColumns');

            //self.kendoSortAvailable = self.$available.kendoSortable({ placeholder: self.$holder}).data('kendoSortable');
            //self.kendoSortTaken = self.$taken.kendoSortable({ placeholder: self.$holder}).data('kendoSortable');

            self.kendoSortAvailable = self.$available.kendoSortable({
                placeholder: self.$holder,
                connectWith: '#takenColumns'
            }).data('kendoSortable');

            self.kendoSortTaken = self.$taken.kendoSortable({
                placeholder: self.$holder,
                connectWith: '#availableColumns'
            }).data('kendoSortable');
        };
        vm.saveClick = function() {
            var self = this;

            var taken = _.map(self.kendoSortTaken.element.children(), function (itm) { return { columnListId: itm.id, columnTitle: itm.outerText, columnName: itm.title }; });
            //var taken = _.map(self.listTaken(), function (data) { return { columnListId: data.value, columnTitle: data.text, columnName: data.title }; });
            
            dataProvider.
                lists
                .updateDisplay(vm.id, taken)
                .done(function (result) {
                    self.notify('success', i19n.to.listupdated);
                    self.reload();
                    setTimeout(function () {
                        self.comboClick(self.id);
                    }, 500);
                })
                .fail(function (result) {
                    self.notify(result.error);
                });
        };
        vm.cancelClick = function () {
            var self = this;

            self.comboClick(self.id);
        };

        //vm.availableClick = function (data) {
        //    vm.listTaken.push(data);
        //    vm.listAvailable.remove(data);
        //};
        //vm.takenClick = function (data) {
        //    vm.listAvailable.push(data);
        //    vm.listTaken.remove(data);
        //};

        return vm;

        function loadData() {
            var self = vm;

            return dataProvider.
                lists
                .getDisplay(vm.id)
                .done(function (result) {
                    var available = _.map(result.availableListColumns, function (data) { return { text: data.columnTitle, value: data.columnListId, title: data.columnName }; });
                    var taken = _.map(result.columnsToDisplay, function (data) { return { text: data.columnTitle, value: data.columnListId, title: data.columnName }; });
                    
                    self.listAvailable(available);
                    self.listTaken(taken);
                })
                .fail(function (result) {
                    self.notify(result.error);
                });
        }
    }
);
